export const clearAllEventName = 'clearAll'
export const openDrawerEventName = 'openDrawer'
export const clearAllEvent = new Event(clearAllEventName)
export const openDrawerEvent = new Event(openDrawerEventName)

export const phishingSOCAgentEventName = 'phishingSOCAgent'
export const phishingSOCAgentEvent = new Event(phishingSOCAgentEventName)
